import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IWarningDialogProps {
    dialogName: string;
    handleConfirm?: () => void;
    hideDialog: () => void;
    selectedClient: number;
    selectedPayPeriod?: string;
    hasProjects: boolean;
    label?: string;
    context: number;
}

const WarningDialog = (props: IWarningDialogProps) => {

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('DefineBudgetCategoryDialog onCreate()');
    };

    const OKClicked = () => {
        props.handleConfirm();
    };

    return (
        <Dialog title="Warning" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '15%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <label>{!!props?.label ? props?.label : `No client selected or no projects defined.`}</label>
                    <br />
                    {props.context === 1 && <label>OK {!props.selectedClient ? 'to select a client' : '' + !props.hasProjects ?
                     'to add a project' : 'to select a project.'}. Cancel to go back.</label>}
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                { props?.context !== 2 && <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />}
            </div>
        </Dialog>
    );
};

export default WarningDialog;



// WEBPACK FOOTER //
// ./src/components/client-project/dialogs/WarningDialog.tsx